// extracted by mini-css-extract-plugin
module.exports = {"hop-Icon":"Icon_hop-Icon__2QpIE"};